import React, { useState, useEffect } from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const RelationshipType = ({
	UDI,
	setUDI,
	forceIsEditing = null,
	auxFieldName
}) => {

	const [errorVar, setErrorVar] = useState(false);

	const fieldName = "RelationshipType";
	const fieldTitle = "Relationship Type";
	const LOV = [

		{ key: "", value: "" },
		{ key: "LEGACY_REGULATION_DEVICE_LINK", value: "Legacy-Regulation Device Link" }

	];


	const validate = () => {

        setErrorVar(false);

		if ((UDI[auxFieldName] && UDI[auxFieldName] != "") && UDI[fieldName] == "") {
			setErrorVar(fieldTitle + " is mandatory if Related Legacy Device has a value");
			return;
		}

    }


	useEffect(() => {

        validate();

	}, [UDI]);


	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />

		{errorVar && (
			<div className="view-task-field">
				<div className="view-task-field-line">
					<div className="view-task-field-title"></div>
					<div className="view-task-field-value">
						<span className="form-field-error-message">
							{errorVar}
						</span>
					</div>
				</div>
			</div>
		)}

	</>											  
}


export default RelationshipType;


